import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

let store = new Vuex.Store({
    state: {
        authToken: null,
        homeHTML: {},
        tenant: {},
        user: {},
        queue: {},
        /**
         * Si se accede al portal con el parametro q=21, se fija a la oficina seleccionada {id:21, name: 'xxx' }.
         * Luego se usa para ocultar botones y restringir la navegacion a dicha oficina.
         */
        useSingleQueue: null,
        servicePoint: {},
        serviceChannel: {},
        visitor: {},
        comments: null,
        ticket: {},
        error: {},
        teleconfURL: {},
        languages: [],
        configuration: {}
    },
    mutations: {
        setAuthToken(currentState, value) {
            window.console.log('store::setAuthToken>' + value)
            Vue.set(currentState, 'authToken', value);
        },
        setTeleconfURL(currentState, value) {
            Vue.set(currentState, 'teleconfURL', value);
        },
        setHomeHTML(currentState, value) {
            // window.console.log('store::setHomeHTML>', value)
            Vue.set(currentState, 'homeHTML', value);
        },
        setTenant(currentState, value) {
            window.console.log('store::setTenant>', value)
            Vue.set(currentState, 'tenant', value);
        },
        setUser(currentState, value) {
            window.console.log('store::setUser>', value)
            Vue.set(currentState, 'user', value);
            Vue.set(currentState, 'tenant', value.tenant);
        },
        setQueue(currentState, value) {
            window.console.log('store::setQueue>', value)
            Vue.set(currentState, 'queue', value);
        },
        setUseSingleQueue(currentState, value) {
            window.console.log('store::setUseSingleQueue>', value)
            Vue.set(currentState, 'useSingleQueue', value);
        },
        setServicePoint(currentState, value) {
            window.console.log('store::setServicePoint>', value)
            Vue.set(currentState, 'servicePoint', value);
        },
        setServiceChannel(currentState, value) {
            window.console.log('store::setServiceChannel>', value)
            Vue.set(currentState, 'serviceChannel', value);
        },
        setVisitor(currentState, value) {
            window.console.log('store::setVisitor>', value)
            Vue.set(currentState, 'visitor', value);
        },
        setComments(currentState, value) {
            window.console.log('store::setComments>', value)
            Vue.set(currentState, 'comments', value);
        },
        setTicket(currentState, value) {
            window.console.log('store::setTicket>', value)
            Vue.set(currentState, 'ticket', value);
        },
        setError(currentState, value) {
            window.console.log('store::setError>', value)
            Vue.set(currentState, 'error', value);
        },
        setLanguages(currentState, value) {
            window.console.log('store::setLanguages>', value)
            Vue.set(currentState, 'languages', value);
        },
        setLanguage(currentState, value) {
            window.console.log('store::setLanguage>', value)
            Vue.set(currentState, 'language', value);
            // window.vueinstance se fija en main.js
            Vue.set(window.vueinstance.$i18n, 'locale', value.name);
            // accesibilidad
            document.documentElement.setAttribute('lang', value.locale)
            // hace que se redibuje la pantalla
            window.vueinstance.$forceUpdate();
        },
        setConfiguration(currentState, value) {
            window.console.log('store::setConfiguration>', value)
            Vue.set(currentState, 'configuration', value);
        }
    }
})


export default store;

